import { PageStatusType } from '@/asset/AssetTask/templates/Cascade/type';
import { Api, sorterToSql } from '@/utils';
import _ from 'lodash';
import moment from 'moment';
import { promiseCacher } from '@cui/lcp-tools';

const assetBaseUrl = '/api/gateway/metabase';
/*
 * @Author: sfy
 * @Date: 2023-01-16 13:39:15
 * @LastEditors: sfy
 * @LastEditTime: 2023-02-14 13:59:31
 * @FilePath: /lcp-asset/packages/lcp-pro/src/api/cascade.ts
 * @Description: update here
 */

function recursiveObj(obj) {
  for (const k in obj) {
    if (obj.hasOwnProperty(k)) {
      // 时区处理，默认全部转化为相对于北京的时间戳
      if (moment.isMoment(obj[k])) {
        obj[k] = obj[k].valueOf();
      } else if (obj[k] === undefined || obj[k] === '') {
        // console.log(`${k}:${obj[k]}`)
        obj[k] = null;
      } else if (_.isObject(obj[k])) {
        recursiveObj(obj[k]);
      }
    }
  }
}

// 头行结构创建
export const createAssetCascadeData = async (
  params: any,
  taskId: string,
  type: PageStatusType,
  urlOpenVersion?: boolean,
  urlVersion?: string,
  approverSetData?: any,
  fsToken?: string,
): Promise<any> => {
  recursiveObj(params);
  const data = {
    multiLevelRecords: params,
    taskId,
    version: urlOpenVersion ? (urlVersion || '1') : urlVersion,
    openVersion: urlOpenVersion,
  };
  if (approverSetData) {
    data.approverSetData = approverSetData;
  }
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/${type === 'add' ? 'compose_multi_level_create' : 'compose_multi_level_operation'}`,
    data,
    headers: (type === 'add' && fsToken) ? { 'F-S-TOKEN': fsToken } : {},
  });
  return res[1] || {};
};
// 头更新审批
export const approvalheadRecordData = async (params: any, taskId: string): Promise<any> => {
  recursiveObj(params);
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/start_approval`,
    data: {
      headRecord: params,
      taskId,
    },
  });
  return res[1] || {};
};


// 头行结构查询
export const findAssetCascadeData = async (params: {
  taskId: string;
  recordId?: string;
  version?: string;
  pageModuleConfig?: {
    [moduleName: string]: { sorter?: { field?: string; order?: string } };
  };
}): Promise<any> => {
  const { taskId, recordId, version, pageModuleConfig } = params;
  const url = `${assetBaseUrl}/compose_batch/multi_level_query_records/taskId/${taskId}/recordId/${recordId}`;
  const data: {
    queryOption?: Array<{ model: string; sort: string }>;
    version?: string;
  } = {
    // queryOption: [{ model: 'rule_calc_row', sort: 'price_base-' }],
  };
  if (pageModuleConfig) {
    Object.keys(pageModuleConfig).forEach((moduleName) => {
      if (pageModuleConfig[moduleName]?.sorter?.field && pageModuleConfig[moduleName]?.sorter?.order) {
        data.queryOption = data.queryOption || [];
        data.queryOption.push({ model: moduleName, sort: sorterToSql(pageModuleConfig[moduleName].sorter) });
      }
    });
  }
  if (version) {
    data.version = version;
  }
  const res = await Api({
    method: 'post',
    url,
    data,
  });
  return res[1] || {};
};

// 头行结构删除

export const deleteAssetCascadeData = async (params: any): Promise<any> => {
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/compose_multi_level_delete`,
    data: params,
  });
  return res[1] || {};
};


// 根据任务查规则
export const getTaskRules = async (params: any): Promise<any> => {
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/query_rule_scene_by_taskId`,
    data: params,
  });
  return res[1] || {};
};
export const getTaskRulesCache = promiseCacher(getTaskRules);


// 批量删除 old
export const delAssetDataList = async ({ delName, ns, module, idList }): Promise<any> => {
  const [err, res] = await Api({
    method: 'delete',
    url: `${assetBaseUrl}/api/v1/${ns}/${module}/delete_batch`,
    data: {
      condition: `${delName} in (\${p_id})`,
      parameters: { p_id: idList },
    },
  });
  return res || {};
};

// 头行结构创建 old
export const createAssetData = async (params: any): Promise<any> => {
  recursiveObj(params);
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/compose_batch_create`,
    data: params,
  });
  return res[1] || {};
};
// 头行结构更新 old
export const updataAssetData = async (params: any): Promise<any> => {
  recursiveObj(params);
  const res = await Api({
    method: 'post',
    url: `${assetBaseUrl}/serviceFlow/api/compose_batch_operation_records`,
    data: params,
  });
  return res[1] || {};
};

// 单record删除 old
export const delAssetData = async ({ ns, module, id }): Promise<any> => {
  const [err, res] = await Api({
    method: 'delete',
    url: `${assetBaseUrl}/api/v1/${ns}/${module}/delete/${id}`,
  });
  return res || {};
};

// 获取审批人设置信息
export const getApproverSettingInfo = async ({ taskId }): Promise<any> => {
  const [err, res] = await Api({
    method: 'get',
    url: `/api/gateway/process_platform/process/start/instance/check/${taskId}`,
  });
  return res || {};
};

// 根据角色获取用户
export const getUserByRole = async (data?: any): Promise<any> => {
  const [err, res] = await Api({
    method: 'post',
    url: '/api/gateway/system/role/users',
    data,
  });
  return res?.data;
};

// 基础数据模型对应recordList通用请求接口
export const getBaseRecordList = async ({
  modelId,
  data,
  appId,
}: any) => {
  const [err, res] = await Api({
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/page`,
    method: 'POST',
    data,
  });
  return res?.data;
};

/**
 * 获取跟userAccount在相同二级组织下的拥有某些角色的用户
 * @param roleNumbers
 * @param userAccount
 * @returns
 */
export const getUserOfCompanyByRoles = async (roleNumbers: string[], userAccount?: string) => {
  const [err, res] = await Api({
    url: `/api/gateway/system/user/v2/fetchUserForCompanyByRoles/${userAccount}/roleNumbers`,
    method: 'POST',
    data: roleNumbers,
  });
  return res?.data;
};
